module.exports = __webpack_public_path__ + "static/media/mode-40.7cb24d9b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Containers/Workspace/Tools/GgbIcons/mode-40.svg
// module id = 995
// module chunks = 2